// extracted by mini-css-extract-plugin
export default {"bgVideoWrapper":"BgVideo_bgVideoWrapper__YM-hU","fadeVideo":"BgVideo_fadeVideo__zuhDP"};